// $('a').each(function () { 
//   // Check if the link is external 
//   if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'www.lindystitches.com') { 
//     // Create a span element with warning text 
//     var warningSpan = $('<span class="visually-hidden">: Redirecting to a third-party website (opens in a new tab)</span>'); 
//     // Set attributes for accessibility 
//     $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer'); 
//     // Append the warning span inside the link 
//     $(this).append(warningSpan); 
//   } 
// }); 


$(document).ready(function () {
  const currentHost = window.location.hostname.replace("www.", "");
  const warningText =
    " Redirecting to a third-party website (opens in a new tab).";

  $('a[href^="http://"], a[href^="https://"]').each(function () {
    const $link = $(this);
    const linkHost = this.hostname.replace("www.", "");

    if (linkHost === currentHost || !linkHost) return;

    let linkText = $link.text().trim();

    if (!linkText) {
      const imgAlt = $link.find("img").attr("alt");
      linkText = imgAlt ? imgAlt.trim() : "this link";
    }

    const currentAriaLabel = $link.attr("aria-label");

    const newLabel = currentAriaLabel
      ? `${currentAriaLabel}${warningText}`
      : `${linkText}${warningText}`;

    $link.attr({
      "aria-label": newLabel,
      "title": newLabel,
      "target": "_blank",
      "rel": "noopener noreferrer nofollow"
    });

    $link.addClass("external-link");
  });
});




// back to top

document.addEventListener('DOMContentLoaded', function() { 
 var backToTopButton = document.getElementById('back-to-top'); 

 window.onscroll = function() { 
  if (window.pageYOffset > 300) { 
  backToTopButton.style.display = 'block'; 
   } else { 
   backToTopButton.style.display = 'none'; 
   } 
  }; 

  backToTopButton.onclick = function(e) { 
  e.preventDefault(); 
   window.scrollTo({ top: 0, behavior: 'smooth' }); 

 // Set focus to the top of the page or the button itself after scrolling 
   window.setTimeout(function() { 
   document.getElementById('backtoheader').focus(); // If focusing the top element 
 // backToTopButton.focus(); // If focusing the button itself 
 }, 600); // Adjust the timeout duration to match the scroll duration 
 }; 
}); 




document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.disclosure__button').forEach((button) => {
    button.addEventListener('click', () => {
      requestAnimationFrame(() => {
        if (button.getAttribute('aria-expanded') === 'true') {
          button.focus();
        }
      });
    });
  });
});




// Smile.io loyalty iframes ship a viewport meta that disables zoom and px font sizes (WCAG 1.4.4)

(function () {
  const allowZoom = (frame) => {
    try {
      const doc = frame.contentDocument;
      if (!doc || !doc.head) return;
      const meta = doc.querySelector('meta[name="viewport"]');
      if (meta && /user-scalable|maximum-scale/i.test(meta.content)) {
        meta.setAttribute('content', 'width=device-width,initial-scale=1');
      }
      if (!doc.getElementById('relative-font-sizes')) {
        const style = doc.createElement('style');
        style.id = 'relative-font-sizes';
        style.textContent = 'body{font-size:0.875rem}button{font-size:1rem}';
        doc.head.appendChild(style);
      }
    } catch (e) {}
  };

  const watchFrame = (frame) => {
    if (frame.dataset.zoomFix) return;
    frame.dataset.zoomFix = 'true';
    frame.addEventListener('load', () => allowZoom(frame));
    allowZoom(frame);
  };

  const scan = () => document.querySelectorAll('iframe[id^="smile-"]').forEach(watchFrame);

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
